<template>
  <div @click.stop="clickContainer" :class="`options_container ${showOptions ? 'shown' : ''}`">
    <h1>Les langues</h1>
    <div class="langues">
      <div v-for="(langue, index) in selectedLangues" :key="`Langue_${index}`"
        :class="`langue  ${index == currentLang ? 'active' : ''}`" @click.stop="changeLangue(index)">
        {{ langue.key }}
      </div>
    </div>

    <div class="contacts">
      <div class="footer_item bordered" v-if="restau.hours">
        <h1>HORAIRES</h1>

        <span v-for="(hour, index) in restau.hours" :key="`hour_${index}`" class="footer_text"><strong>{{ hour.title }}
          </strong> {{ hour.value }}</span>
      </div>
      <div class="footer_item bordered">
        <h1>Contact</h1>
        <span class="footer_text"><strong>Telephone : </strong> {{ restau.phone }}</span>
        <span class="footer_text"><strong>Email : </strong>{{ restau.email }}</span>
        <span class="footer_text"><strong>Adresse : </strong> {{ restau.address }}</span>
        <span class="footer_text" v-if="restau.reseau"><strong>Site web : </strong><a :href="restau.reseau.web"
            class="link_url">
            {{ restau.reseau.web }}</a></span>
      </div>
    </div>
    <div class="social" v-if="restau.reseau">
      <a :href="`${restau.reseau.facebook}`" class="fab fa-facebook"></a>
      <a :href="`${restau.reseau.instagram}`" class="fab fa-instagram"></a>
      <a :href="`${restau.reseau.twitter}`" class="fab fa-twitter"></a>
    </div>
  </div>
</template>

<script>
// :showOptions="showOptions" :restau="currentRestau?currentRestau:{}" :currentLang="currentLang" :selectedLangues="selectedLangues"
export default {
  props: [
    "selectedLangues",
    "restau",
    "showOptions",
    "currentLang",
    "changeLangue",
  ],
  methods: {
    clickContainer() {
      this.$emit("clickParent")
    },

  },
  data() {
    return {};
  },
};
</script>
<style>
.footer_item.bordered {
  margin-top: 24px;
}

#langues {
  background: #ff9800;
}

#langues_container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 99999999;
  padding: 5px;
  margin: 10px;
  color: white;
}

.custom_label {
  font-size: 12px;
  margin-left: 2px;
}

.subsection {
  display: flex;
  justify-content: space-between;
  background: #eeeeee;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 5px;
  color: #263238;
  align-items: center;
  font-weight: 600;
  display: none;
  cursor: pointer;
}

.subsection span {}

.subsection img {
  width: 12px;
  height: 12px;
  filter: contrast(0.5);
}

.more_options img {
  width: 22px;
}

.more_options {
  width: 40px;
  height: 50px;
  background: #F05D2E;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 10%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  z-index: 9999;
}

.more_options.hideen_section {
  right: 0px;
  animation-name: more_options_out;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
}

@media screen and (max-width : 600px) {
  .more_options {
    top: 20%;

  }
}

/* .options {
  width: 38px;
} */
.more_options.shown {
  right: 260px;
  animation-name: more_options;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
}

.options_container {
  /* position: fixed; */
  /* height: 100%; */
  width: 100%;
  padding-top: 42px;
  background: transparent;
  right: -295px;
  top: 0px;
  z-index: 999999999;
  -webkit-box-shadow: -1px 0px 5px 0px #00000042;
  -moz-box-shadow: -1px 0px 5px 0px #00000042;
  box-shadow: -1px 0px 5px 0px #00000042;
  padding: 12px;
  text-align: left;
}

.options_container.hideen_section {
  right: -295px;
  animation-name: options_container_out;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
}

.options_container.shown {
  /* position: fixed; */
  /* height: 100%;
  width: 260px; */
  /* background: #fff; */
  right: 0px;
  top: 0px;
  z-index: 999999999;
  -webkit-box-shadow: -1px 0px 5px 0px #00000042;
  -moz-box-shadow: -1px 0px 5px 0px #00000042;
  box-shadow: -1px 0px 5px 0px #00000042;
  padding: 12px;
  animation-name: options_container;
  animation-duration: 0.3s;
  animation-timing-function: ease-in-out;
}

@keyframes options_container {
  from {
    right: -260px;
  }

  to {
    right: 0px;
  }
}

@keyframes more_options {
  from {
    right: 0px;
  }

  to {
    right: 284px;
  }
}

@keyframes options_container_out {
  from {
    right: 0px;
  }

  to {
    right: -295px;
  }
}

@keyframes more_options_out {
  from {
    right: 260px;
  }

  to {
    right: 0px;
  }
}

@keyframes options_container {
  from {
    right: -260px;
  }

  to {
    right: 0px;
  }
}

@keyframes more_options {
  from {
    right: 0px;
  }

  to {
    right: 284px;
  }
}

@keyframes options_container_out {
  from {
    right: 0px;
  }

  to {
    right: -295px;
  }
}

@keyframes more_options_out {
  from {
    right: 260px;
  }

  to {
    right: 0px;
  }
}

.options_container h1 {
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}

.langue {
  background: #f7f6f4;
  padding: 12px;
  /* border-bottom: 3px white solid; */
  text-transform: uppercase;
  cursor: pointer;
  color: #000;
}

.langue.active {
  background: #F05D2E;
  color: white;
}

@-webkit-keyframes rotating

/* Safari and Chrome */
  {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.rotating {
  /* -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite; */
}

.fab {
  padding: 12px;
  font-size: 20px;
  width: 50px;
  text-align: center;
  text-decoration: none;
}

/* Add a hover effect if you want */
.fab:hover {
  opacity: 0.7;
}

/* Set a specific color for each brand */

/* Facebook */
.fa-facebook {
  background: #3b5998;
  color: white;
}

/* Twitter */
.fa-twitter {
  background: #55acee;
  color: white;
}

/* Twitter */
.fa-instagram {
  background: #f09433;
  background: -moz-linear-gradient(45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%);
  background: -webkit-linear-gradient(45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%);
  background: linear-gradient(45deg,
      #f09433 0%,
      #e6683c 25%,
      #dc2743 50%,
      #cc2366 75%,
      #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
  color: white;
}

.social {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  position: absolute;
  bottom: 0px;
  width: 100%;
  right: 0px;
}

.social a {
  flex: 1;
}

.contacts,
.contacts div {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

.contacts .footer_item {
  margin-bottom: 12px;
  width: 100%;
}

.contacts span {
  margin-bottom: 6px;
}

.hours_title {
  font-weight: bold;
  margin-right: 6px;
}

.hours {
  display: flex !important;
  flex-direction: row !important;
}

.footer_text {
  width: 100%;
  background: #f5f5f5;
  padding: 12px 6px;
  font-size: 12px;
  color: #263238;
  text-align: left;
}

.footer_text strong {
  margin-right: 6px;
  font-size: 14px;
}

.link_url {
  text-decoration: underline !important;
  color: #3b5998;
}

@keyframes more_options {
  from {
    right: 0px;
  }

  to {
    right: 260px;
  }
}
</style>
